__turbopack_context__.v({
  "arrow": "linkInfoCard-module-scss-module__fdzq3a__arrow",
  "container": "linkInfoCard-module-scss-module__fdzq3a__container",
  "details": "linkInfoCard-module-scss-module__fdzq3a__details",
  "disabled": "linkInfoCard-module-scss-module__fdzq3a__disabled",
  "row": "linkInfoCard-module-scss-module__fdzq3a__row",
});
